
<template>
  <!-- Best Pizza Start -->
  <section class="best_pizza_area">
    <img src="../assets/img/shape_10.png" alt="shape" class="shape_10" />
    <img src="../assets/img/shape_11.png" alt="shape" class="shape_11" />
    <img src="../assets/img/shape_12.png" alt="shape" class="shape_12" />
    <img src="../assets/img/shape_13.png" alt="shape" class="shape_13" />
    <img src="../assets/img/shape_14.png" alt="shape" class="shape_14" />
    <img src="../assets/img/shape_15.png" alt="shape" class="shape_15" />
    <img src="../assets/img/shape_16.png" alt="shape" class="shape_16" />
    <div class="container">
      <div class="row align-items-center justify-content-between">
        <div class="col-lg-5">
          <div class="best_pizza_right">
            <img src="../assets/img/best_pizza_2.png" alt="img" />
            <img src="../assets/img/shape_17.png" class="shape_17" alt="shape" />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="best_pizza_left">
            <h2><span>EL MEJOR</span>SABOR <span class="text-end">DE LA ZONA</span></h2>
            <img
              src="../assets/img/section_delimiter.png"
              alt="img"
              class="section_devider"
            />
            <p>
              En RM Pizzas cada receta se prepara al momento con ingredientes frescos y
              combinaciones que resaltan el sabor real de una buena pizza. Nuestra masa,
              nuestros ingredientes y nuestro estilo están pensados para que cada bocado
              sea consistente, bien servido y lleno de sabor. Aquí no es solo comer, es
              disfrutar algo bien hecho.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Best Pizza End -->
</template>
<script>
export default {
  name: "BestPizzaArea",
};
</script>



// WEBPACK FOOTER //
// src/components/BestPizzaArea.vue